const GettingStarted = () => import('@/components/GettingStarted');

export default {
  path: '/getting-started',
  component: GettingStarted,
  meta: {
    noMenuItems: true,
    canClickXiftLogo: false
  }
};
